const { VERSION } = require('./version.js')
console.log('parentPage', VERSION)

const MERLIN_HOST = process.env.MERLIN_HOST

function getScripts() {
  const scripts = document.getElementsByTagName('script')
  const scripts_var = []
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src) {
      scripts_var.push(scripts[i].src)
    }
  }

  return scripts_var
}
function isMyScriptLoaded(url) {
  const scripts = document.getElementsByTagName('script')
  for (let i = scripts.length; i--; ) {
    if (scripts[i].src === url) return true
  }
  return false
}

function getQueryParamsSettings() {
  const query = window.location.search.substring(1)
  const params = getQueryParams(query)

  const new_params = {}
  for (const key in params) {
    const new_key = key.charAt(0).toLowerCase() + key.slice(1)
    // Map frequency to recurring_option and ensure uppercase
    if (new_key === 'frequency') {
      new_params['recurring_option'] = params[key].toUpperCase()
      // } else if (new_key === 'merlinMemo') {
      //   // Handle MerlinMemo parameter and keep its name
      //   new_params['merlinMemo'] = params[key];
    } else {
      new_params[new_key] = params[key]
    }
  }

  return new_params
}

function appendScript(script_url, onLoadCallback) {
  if (isMyScriptLoaded(script_url)) {
    // all good - script already loaded
    if (onLoadCallback) onLoadCallback()
  } else {
    const script_tag = document.createElement('script')
    script_tag.src = script_url
    if (onLoadCallback) {
      script_tag.onload = onLoadCallback
    }
    document.body.appendChild(script_tag)
  }
}

// Promise-based script loader with timeout for critical scripts
function loadScript(url, timeout = 10000) {
  return new Promise((resolve, reject) => {
    if (isMyScriptLoaded(url)) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = url

    const timer = setTimeout(() => {
      reject(new Error(`Script load timeout: ${url}`))
    }, timeout)

    script.onload = () => {
      clearTimeout(timer)
      resolve()
    }
    script.onerror = () => {
      clearTimeout(timer)
      reject(new Error(`Script load failed: ${url}`))
    }

    document.body.appendChild(script)
  })
}

function getQueryParams(qs) {
  if (qs) {
    qs = qs.split('+').join(' ')

    const params = {}
    let tokens
    const re = /[?&]?([^=]+)=([^&]*)/g

    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
    }

    return params
  }

  return {}
}

// Load non-blocking scripts (fire and forget)
function addNonBlockingScripts() {
  // Debug logging for postMessage timeout investigation
  window.__merlinDebug = window.__merlinDebug || {}
  window.__merlinDebug.addBeforeScriptsTime = performance.now()

  // Stripe v3 - needed for Apple Pay, but not blocking for form init
  appendScript('https://js.stripe.com/v3/')
}

// Min-height floor so the iframe is never too short before the child reports its
// real height. Dropped by the merlinCartSetHeight listener on the first valid
// message; if the child's JS never delivers, the floor stands.
function addIframeHeightFloor() {
  if (document.getElementById('merlin-form-iframe-floor')) return

  const style = document.createElement('style')
  style.id = 'merlin-form-iframe-floor'
  style.textContent = `
    #merlin-form-iframe { min-height: 900px; }
    @media (min-width: 640px) { #merlin-form-iframe { min-height: 800px; } }
  `
  document.head.appendChild(style)
}

// Load the critical postRobot script - MUST complete before iframe creation
async function loadPostRobotScript() {
  const postRobotUrl = `${MERLIN_HOST}/assets/form-parent-page-post-robot-script.js?vsn=${VERSION}`
  try {
    await loadScript(postRobotUrl)
    window.__merlinDebug = window.__merlinDebug || {}
    window.__merlinDebug.postRobotScriptLoadedTime = performance.now()
    window.__merlinDebug.postRobotScriptLoaded = true
  } catch (e) {
    console.error('Critical postRobot script failed to load:', e)
    // Form will work with degraded functionality (settings passed via URL params only)
    window.__merlinDebug = window.__merlinDebug || {}
    window.__merlinDebug.postRobotScriptFailed = true
    window.__merlinDebug.postRobotScriptError = e.message
  }
}

function addAfterScripts() {
  appendScript('https://js.stripe.com/v2/')
}

function getWidgetKey() {
  const srcs = getScripts()
  const install_script = srcs.find((s) => s.match('form-install-script'))
  const install_query = install_script.split('?')[1]

  const query_parameters = getQueryParams(install_query)

  return query_parameters.key
}

async function initMerlinForm(settings, form_div) {
  // Start loading non-blocking scripts (fire and forget)
  addNonBlockingScripts()

  // CRITICAL: Wait for postRobot script before creating iframe
  // This prevents the race condition where iframe sends postRobot.send()
  // before postRobot.on() listeners are registered
  await loadPostRobotScript()

  const windowSettings = window.simpleDonationMerlinSettings

  const enrichedSettings = Object.assign({}, settings, windowSettings)

  const widget_key = getWidgetKey()
  //
  // Entity and EntityType used for Fundraising Opportunity in Rock
  //
  const rock_entity_type_id =
    enrichedSettings.rockEntityTypeId || enrichedSettings.merlinFormEntityTypeId
  const rock_entity_id = enrichedSettings.rockEntityId || enrichedSettings.merlinFormEntityId

  const store_url =
    enrichedSettings.merlinStoreUrl || window.location.protocol + '//' + window.location.host
  const url = window.location.host + window.location.pathname

  const person_uuid = enrichedSettings.personId

  const rock_businesses = enrichedSettings.rockBusinesses
    ? enrichedSettings.rockBusinesses.map((business) => ({
        ...business,
        Email: business.Email || '',
        Id: String(business.Id),
      }))
    : null

  const primary_color =
    enrichedSettings.merlinPrimaryColor?.replace(/^#/, '') || enrichedSettings.merlinPrimaryColor

  const background_color =
    enrichedSettings.merlinBackgroundColor?.replace(/^#/, '') ||
    enrichedSettings.merlinBackgroundColor

  const test_mode = enrichedSettings.testMode

  const merlin_mode = enrichedSettings.merlinMode

  const default_business = enrichedSettings.merlinDefaultBusiness

  const email = enrichedSettings.email

  const first_name = enrichedSettings.firstName

  const collect_address_for_this_user = !first_name

  const last_name = enrichedSettings.lastName

  const initial_fund_id = enrichedSettings.fundId

  const initial_rock_financial_account_id = enrichedSettings.rockFinancialAccountId

  // Extract address fields from personAddress object
  const personAddress = enrichedSettings.personAddress || {}
  const address_street_1 = personAddress.Street1
  const address_street_2 = personAddress.Street2
  const address_city = personAddress.City
  const address_state = personAddress.State
  const address_postal_code = personAddress.PostalCode
  const address_country = personAddress.Country

  // Cast amount to integer if present
  const initial_amount_cents = enrichedSettings.amountCents
    ? parseInt(enrichedSettings.amountCents, 10)
    : null

  const recurring_option = enrichedSettings.recurring_option

  const allowed_to_logout =
    person_uuid === 'undefined' ||
    person_uuid === 'null' ||
    person_uuid === 'notLoggedIntoRock' ||
    person_uuid === 'rockLoggedInNoSdPerson' ||
    person_uuid === null ||
    person_uuid === undefined ||
    person_uuid === ''

  const person_or_business = default_business === 'true' ? 'business' : 'person'

  const giving_flow = enrichedSettings.givingFlow
  const phone_number = enrichedSettings.phoneNumber
  const text_to_give_number = enrichedSettings.textToGiveNumber

  const settings_with_nulls = {
    address_city: address_city,
    address_country: address_country,
    address_postal_code: address_postal_code,
    address_state: address_state,
    address_street_1: address_street_1,
    address_street_2: address_street_2,
    allowed_to_logout: allowed_to_logout,
    background_color: background_color,
    cart_namespace: enrichedSettings.merlinCartNamespace,
    collect_address_for_this_user: collect_address_for_this_user,
    email: email,
    first_name: first_name,
    giving_flow: giving_flow,
    initial_amount_cents: initial_amount_cents,
    initial_fund_id: initial_fund_id,
    initial_rock_financial_account_id: initial_rock_financial_account_id,
    last_name: last_name,
    memo: enrichedSettings.merlinMemo,
    merlin_mode: merlin_mode,
    merlinLockAmount: enrichedSettings.merlinLockAmount,
    merlinLockContact: enrichedSettings.merlinLockContact,
    merlinRememberMe: enrichedSettings.merlinRememberMe,
    merlinVenmo: enrichedSettings.merlinVenmo,
    person_id: person_uuid,
    person_or_business: person_or_business,
    phone_number: phone_number,
    recurring_option: recurring_option,
    rock_businesses: rock_businesses,
    rock_entity_id: rock_entity_id,
    rock_entity_type_id: rock_entity_type_id,
    store_url: store_url,
    test_mode: test_mode,
    text_to_give_number: text_to_give_number,
    url: url,
    widget_key: widget_key,
  }

  // remove the null or undefined values
  const final_settings = Object.keys(settings_with_nulls).reduce((query, key) => {
    if (settings_with_nulls[key] !== null && settings_with_nulls[key] !== undefined) {
      query[key] = settings_with_nulls[key]
    }
    return query
  }, {})

  // Store final_settings for later use with postRobot
  // Include debug timing info for postMessage timeout investigation
  window.merlinFormSettings = {
    ...final_settings,
    __debug: {
      settingsStoredTime: performance.now(),
      postRobotScriptLoaded: window.__merlinDebug?.postRobotScriptLoaded || false,
      postRobotScriptLoadedTime: window.__merlinDebug?.postRobotScriptLoadedTime || null,
      addBeforeScriptsTime: window.__merlinDebug?.addBeforeScriptsTime || null,
    },
  }

  // Create and append the iframe after settings are set
  addIframeHeightFloor()

  const iframe_tag = document.createElement('iframe')
  iframe_tag.id = 'merlin-form-iframe'
  iframe_tag.allowPaymentRequest = true
  iframe_tag.src = `${MERLIN_HOST}/form?widget_key=${widget_key}&person_id=${person_uuid}&primary_color=${primary_color}`
  iframe_tag.setAttribute(
    'style',
    'margin: 0 !important; padding: 0 !important; border: 0 !important; width: 100% !important; height: 600px;'
  )
  form_div.appendChild(iframe_tag)

  // Debug logging for iframe creation timing
  window.__merlinDebug = window.__merlinDebug || {}
  window.__merlinDebug.iframeCreatedTime = performance.now()

  addAfterScripts()

  //
  // removed 2025-04-28, thecrossingchurch.com doesn't like how it runs the user past all their
  // above the fold content, can I can't think of a good reason to snap to the form on load. If you have
  // text content above the form we shouldn't skip that, if you don't, then what are we scolling to anyway?
  // feel free to delete this comment and code after 2025-12-31
  //
  // setTimeout(() => {
  //   window.scrollTo(0, 0);
  // }, 800);
}

const form_div = document.getElementById('merlin-form')

if (form_div) {
  const dataset = form_div.dataset
  const parent_page_query_param_settings = getQueryParamsSettings()
  const data = Object.assign({}, dataset, parent_page_query_param_settings)
  initMerlinForm(data, form_div)
}
